var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7123 14.24V16.9497C18.7134 17.2013 18.6617 17.4503 18.5607 17.6808C18.4598 17.9113 18.3117 18.1182 18.1259 18.2882C17.9402 18.4583 17.7209 18.5877 17.4822 18.6683C17.2434 18.7489 16.9904 18.7789 16.7394 18.7562C13.9544 18.4542 11.2793 17.5045 8.9289 15.9833C6.74218 14.5965 4.88823 12.7462 3.49869 10.5638C1.96917 8.20744 1.01731 5.52462 0.720237 2.7327C0.69762 2.48293 0.727364 2.23119 0.807573 1.99351C0.887782 1.75584 1.0167 1.53743 1.18612 1.35221C1.35554 1.16698 1.56174 1.01899 1.79161 0.91766C2.02148 0.816328 2.26996 0.763874 2.52126 0.763637H5.23636C5.67558 0.759323 6.10139 0.91455 6.43441 1.20038C6.76744 1.48622 6.98496 1.88316 7.04643 2.31721C7.16103 3.18439 7.37356 4.03584 7.67996 4.85532C7.80172 5.17862 7.82808 5.52997 7.75589 5.86775C7.68371 6.20553 7.51602 6.51558 7.27269 6.76116L6.1233 7.90828C7.41166 10.1696 9.28771 12.0419 11.5535 13.3277L12.7029 12.1806C12.949 11.9378 13.2596 11.7704 13.5981 11.6984C13.9365 11.6263 14.2886 11.6526 14.6125 11.7742C15.4336 12.0799 16.2868 12.2921 17.1557 12.4064C17.5953 12.4683 17.9968 12.6893 18.2838 13.0274C18.5708 13.3655 18.7233 13.797 18.7123 14.24Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.8ab55167a1949ce92507de0d80d0fc94.svg";
export { ForwardRef as ReactComponent };